<template>
  <div v-if="annotationsLoaded">
    <!-- Debug Images: {{ images }} -->
    <o-field>
      <o-button
        :label="annotationEditMod ? 'Save bounding box' : 'Edit bounding box'"
        :variant="annotationEditMod ? 'info' : 'warning'"
        @click="changeAnnotationEditMod"
        class="is-pulled-right mb-1"
        v-if="keycloakGetStatusAuthenticated"
      />
    </o-field>

    <o-field>
      <Sidebar
        :sidebarObj="sidebarObj"
        @setOwnComment="
          (newValue) => {
            sidebarObj.originalAnnotation.sidebarObj.ownComment = newValue;
          }
        "
        @setTaxonID="
          (id) => {
            sidebarObj.originalAnnotation.sidebarObj['taxonID'] = id;
          }
        "
        @delete="
          (id) => {
            deleteAnnotation(id);
          }
        "
      />

      <o-carousel
        :autoplay="false"
        :overlay="gallery"
        iconPack="fa"
        :has-drag="!annotationEditMod"
      >
        <o-carousel-item v-for="(item, i) in images" :key="i">
          <a class="image">
            <img
              :src="item.URL"
              :id="'imageBox_' + i"
              :onload="initAnnotationFunctionality"
              :data-item-id="item.id"
            />
          </a>
        </o-carousel-item>

        <template #indicators="{ active, switchTo }" v-if="!annotationEditMod">
          <o-carousel
            :value="active"
            @input="switchTo($event)"
            v-bind="al"
            as-indicator
          >
            <o-carousel-item
              v-for="(item, i) in images"
              :key="i"
              item-class="img-indicator"
              item-active-class="img-indicator-active"
              :class="{
                'img-indicator-active': active === i,
              }"
              :id="'fixFirstThumb' + i"
            >
              <img :src="item.URL" @click="switchTo(i)" />
            </o-carousel-item>
          </o-carousel>
          <!-- {{ !fixFirstThumb_ready && active > 0 ? this.fixFirstThumb() : "" }} -->
        </template>

        <template #overlay>
          <o-icon
            v-if="gallery"
            icon=" fa fa-times-circle"
            root-class="ex-close-icon"
            clickable
            @click="switchGallery(false)"
          />
        </template>
      </o-carousel>
    </o-field>
  </div>
</template>

<script setup>
import Sidebar from "@/components/Sidebar.vue";
</script>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

import { Annotorious } from "@recogito/annotorious";
import "@recogito/annotorious/dist/annotorious.min.css";

import CordraMixin from "@/mixins/cordra";

export default {
  name: "BoundingBox",
  mixins: [CordraMixin],

  props: ["images"],

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      fixFirstThumb_ready: false,

      annotoriousObjects: [], // Each object is an image
      annotationEditMod: false,

      annotations: {}, // Here you go annotations indexed with image title
      annotationScore: {}, //Here you go machine-annotated scores, if avaiable. Format: ID:score
      annotationDeleteCordraObjectID: [],

      annotationsLoaded: false,
      allRelatedAnnotations: {}, // All annotations for this view
      annotoriousJSON: {
        type: "Annotation",
        sidebarObj: {}, // Object only for a annotation.
        body: [
          // {
          //   type: 'TextualBody',
          //   value: '',
          //   purpose: 'commenting',
          // },
          // {
          //   type: 'TextualBody',
          //   purpose: 'tagging',
          //   value: 'Test-tag',
          // },
        ],
        target: {
          source: "not necessary",
          selector: {
            type: "FragmentSelector",
            conformsTo: "http://www.w3.org/TR/media-frags/",
            value: "xywh=pixel:146,71,625,425",
          },
        },
        "@context": "http://www.w3.org/ns/anno.jsonld",
        id: "#1 Overwrite me with unique value",
      },

      gallery: false,
      al: {
        itemsToShow: 2,
        breakpoints: {
          768: {
            itemsToShow: 4,
          },
          960: {
            itemsToShow: 6,
          },
        },
      },

      sidebarObj: {
        open: false,
        annotationEditMod: this.annotationEditMod,
      }, // Object only for the SideBar Component
    };
  },

  methods: {
    ...mapMutations({ newMessage: "messenger/newMessage" }),

    fixFirstThumb() {
      console.log(
        "fixFirstThumb()",
        "optimize me",
        document
          .getElementById("fixFirstThumb0")
          .classList.contains("img-indicator-active")
      );
      // We need to fix the first thumb manually, otherwise there is a static class "img-indicator-active"

      if (
        document
          .getElementById("fixFirstThumb0")
          .classList.contains("img-indicator-active")
      ) {
        document
          .getElementById("fixFirstThumb0")
          .classList.remove("img-indicator-active");
      } else {
        // class created from Annotorious and allready fixed. Don't try to fix again.
        this.fixFirstThumb_ready = true;
      }
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    changeAnnotationEditMod() {
      this.annotationEditMod = !this.annotationEditMod;
      this.sidebarObj.annotationEditMod = this.annotationEditMod;

      if (!this.annotationEditMod) {
        this.createCordraUpdateObject();
      }

      this.annotoriousObjects.forEach((element) => {
        element.readOnly = !this.annotationEditMod;
        element.cancelSelected();
      });
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    coordinatesCordraToAnnotorious(coordinates) {
      let annotoriousCoordinates = [
        coordinates[0],
        coordinates[1],
        coordinates[2] - coordinates[0],
        coordinates[3] - coordinates[1],
      ];
      return annotoriousCoordinates;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    coordinatesAnnotoriousToCordra(coordinates) {
      // console.group("coordinatesAnnotoriousToCordra()", coordinates);
      let restoredCoordinates = "xywh=" + coordinates.split(":")[1];

      // console.log("restoredCoordinates", restoredCoordinates);
      // console.groupEnd();

      return restoredCoordinates;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async createCordraUpdateObject() {
      console.group("createCordraUpdateObject");
      // console.log("annotoriousObjects", this.annotoriousObjects);
      // console.warn("this.allRelatedAnnotations", this.allRelatedAnnotations);

      let newComments = [];
      let newAllRelatedAnnotations = JSON.parse(
        JSON.stringify(this.allRelatedAnnotations)
      );

      console.log(
        "newAllRelatedAnnotations (to edit the boundingBoxes)",
        newAllRelatedAnnotations
      );

      for (var singleImage of this.annotoriousObjects) {
        let newAnnotationIDs = [];
        for (var singleAnnotation of singleImage.getAnnotations()) {
          console.group("singleImage.getAnnotations().forEach");
          console.log("annotoriousObjects singleImage", singleImage);
          console.log("annotoriousObjects singleAnnotation", singleAnnotation);

          let [cordraID, annotationIndex] =
            singleAnnotation.id.split("_localID_");
          console.log("cordraID", cordraID, "annotationIndex", annotationIndex);

          // Update if allready stored
          for (var annotationList in newAllRelatedAnnotations) {
            console.group(
              "newAllRelatedAnnotations[annotationList] - a List of annotations of an image",
              newAllRelatedAnnotations[annotationList]
            );

            for (var singleCordraAnnotation of newAllRelatedAnnotations[
              annotationList
            ]) {
              console.log(
                "Next step: check singleCordraAnnotation:",
                singleCordraAnnotation
              );

              if (singleCordraAnnotation.id === cordraID) {
                console.log(
                  "ID matched, singleCordraAnnotation.id:",
                  singleCordraAnnotation.id
                );

                let restoredCoordinates = this.coordinatesAnnotoriousToCordra(
                  singleAnnotation.target.selector.value
                );

                console.log("restoredCoordinates", restoredCoordinates);

                if (
                  JSON.stringify(
                    singleCordraAnnotation.content["hasTarget"]["hasSelector"][
                      "value"
                    ]
                  ) != JSON.stringify(restoredCoordinates)
                ) {
                  console.group("Different coordinates");
                  console.warn(
                    "Update singleCordraAnnotation",
                    singleCordraAnnotation
                  );

                  singleCordraAnnotation.content["hasTarget"]["hasSelector"][
                    "@value"
                  ] = restoredCoordinates;

                  singleCordraAnnotation.content["annotationQuality"] =
                    "human-detected";

                  singleCordraAnnotation["updated"] = true;

                  console.warn(
                    "Update singleCordraAnnotation ready",
                    singleCordraAnnotation
                  );

                  console.groupEnd();
                }

                // New Comment for existing annotations
                if (singleAnnotation.sidebarObj.ownComment != "") {
                  console.log("create a new comment here");
                  var annotationID = singleAnnotation.id.split("_");
                  annotationID = annotationID[0];

                  var annotationCommentTest1 = this.createAnnotationComment(
                    annotationID,
                    singleAnnotation.sidebarObj.ownComment
                  );

                  newComments.push(annotationCommentTest1);
                }
              }
            }

            console.groupEnd();
          }

          /////////////////////////////////////////////////////////////// Here you create a new box
          if (annotationIndex === undefined) {
            console.group(
              "New singleAnnotation detected! annotationIndex is undefined here"
            );
            console.log(
              "annotoriousObjects singleAnnotation",
              singleAnnotation
            );
            console.log("now serach for an appropriate node");
            console.log(
              "singleAnnotation.target.source",
              singleAnnotation.target.source
            );
            let imageURI = singleAnnotation.target.source.split("/");
            imageURI = imageURI[imageURI.length - 1]; // .split("/")[-1] doesn't work for Chromium

            for (var singleImageofImages of this.images) {
              // console.log("Element of images", singleImageofImages);
              // console.log("imageURI", imageURI);

              let singleImageofImagesURI = singleImageofImages.URL.split("/");
              singleImageofImagesURI =
                singleImageofImagesURI[singleImageofImagesURI.length - 1];

              console.log("singleImageofImagesURI", singleImageofImagesURI);

              if (imageURI === singleImageofImagesURI) {
                console.log("Found", singleImageofImages.URL);

                let newAnnotationObjForCordra = this.createCordraObject(
                  singleAnnotation,
                  singleImageofImages.id
                );

                let annotationID = await this.cordraCreateDocument(
                  newAnnotationObjForCordra
                );
                newAnnotationIDs.push(annotationID.id);

                // New Comment for a new annotations
                if (singleAnnotation.sidebarObj.ownComment != "") {
                  console.log("create a new comment here");

                  var annotationCommentTest2 = this.createAnnotationComment(
                    annotationID.id,
                    singleAnnotation.sidebarObj.ownComment
                  );

                  newComments.push(annotationCommentTest2);
                }

                console.log("newAnnotationIDs in the loop", newAnnotationIDs);

                console.warn(
                  "newAnnotationObjForCordra:",
                  newAnnotationObjForCordra
                );
                break;
              }
            }
          }

          console.groupEnd();
        }
        console.log("newAnnotationIDs:", newAnnotationIDs);

        // this.cordraCreateTemporaryClient()
        //   .callMethod(singleImageofImages.id, "addAnnotationReference", {
        //     annotationId: newAnnotationIDs,
        //   })
        //   .then((result) => {
        //     console.log("New Annotation added:", result);
        //   });
      } // End main loop

      console.group(
        "\n\nnewAllRelatedAnnotations after main loop",
        newAllRelatedAnnotations
      );
      for (var imageAnnotations in newAllRelatedAnnotations) {
        console.log(
          "imageAnnotations",
          newAllRelatedAnnotations[imageAnnotations]
        );
        for (singleAnnotation in newAllRelatedAnnotations[imageAnnotations]) {
          console.log(
            "singleAnnotation",
            newAllRelatedAnnotations[imageAnnotations][singleAnnotation]
          );
          let updateObj =
            newAllRelatedAnnotations[imageAnnotations][singleAnnotation];
          // console.log("updateObj", updateObj);

          if (updateObj.updated) {
            var finalUpdateObj = {
              id: updateObj.id,
              content: updateObj.content,
            };
            delete finalUpdateObj.content.id; // id is not a part of the Schema.
            delete finalUpdateObj.content.updated; // updated is not a part of the Schema.

            console.warn("Update Annotation, finalUpdateObj:", finalUpdateObj);
            this.cordraUpdateDocument(finalUpdateObj);
          } else {
            console.log("There are no updates for updateObj:", updateObj);
          }
        }
      }

      // Create new Comments
      for (var singleNewComment of newComments) {
        console.warn("Create new comment", singleNewComment);
        var response = this.cordraCreateDocument(singleNewComment);
        console.log("response", response);
      }

      // Delete annotations
      for (var deleteID of this.annotationDeleteCordraObjectID) {
        console.warn("Delete Annotation", deleteID);
        this.cordraDeleteDocument(deleteID);
      }

      console.groupEnd();
      console.groupEnd();
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    createCordraObject(annotoriousObjekt, forMediaObject) {
      // console.log('createCordraObject');
      let restoredCoordinates = this.coordinatesAnnotoriousToCordra(
        annotoriousObjekt.target.selector.value
      );

      let annotationObject = {
        type: process.env.VUE_APP_CORDRA_DATATYPE_ANNOTATION,
        content: {
          ["hasTarget"]: {
            source: forMediaObject,
            ["hasSelector"]: {
              ["value"]: restoredCoordinates,
            },
          },
          hasBody: {
            ["acceptedNameUsageID"]: "none",
          },

          ["creator"]: { name: "Charles Darwin" },
          ["annotationQuality"]: "human-detected",
        },
      };

      return annotationObject;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    initAnnotationFunctionality(event) {
      console.group("initAnnotationFunctionality()");
      // *****************************************
      // initialize annotorious callback functinos
      // *****************************************
      let formatter = () => {
        return {
          style: "stroke-width:3; stroke: #FA5882",
          // style: "stroke-width:3; stroke: yellow",
        };
      };

      // console.log("formatter ready");

      let config = {
        image: event.currentTarget,
        // widgets: ["COMMENT"],

        allowEmpty: true,

        readOnly: !this.annotationEditMod, // Static initial value, later you have to change it manually.

        formatter: formatter,
      };
      // console.log("Anno config ready");

      let annotoriousForImage = new Annotorious(config);
      annotoriousForImage.sidebarObj = this.sidebarObj;
      annotoriousForImage.disableEditor = true;

      // init annotation functionality
      // console.log("this.annotations (all annotations)", this.annotations);

      annotoriousForImage.on("cancelSelected", () => {
        console.log("cancelSelected");
        this.closeAnnotation();
      });

      annotoriousForImage.on("createSelection", () => {
        console.log("createSelection");
        this.closeAnnotation();
      });

      annotoriousForImage.on("createAnnotation", (annotation) => {
        // A new Annotation (Bounding Box) was created. Now create some placehoder and open the Sidebar-component.
        console.log("create annotation", annotation);

        this.sidebarObj = {
          open: true,
          annotationEditMod: this.annotationEditMod,
        };

        annotation.sidebarObj = {};
        annotation.sidebarObj["score"] = "";
        annotation.sidebarObj["annotationQuality"] = "";
        annotation.sidebarObj["taxonID"] = "NIL";
        annotation.sidebarObj["ownAnnotation"] = true;

        annotation.sidebarObj.ownComment = ""; // default: empty new comment

        this.sidebarObj["originalAnnotation"] = annotation;

        this.sidebarObj.open = true;
      });

      // openExistentAnnotation
      annotoriousForImage.on("clickAnnotation", (annotation) =>
        this.openExistentAnnotation(annotation)
      );
      annotoriousForImage.on("selectAnnotation", (annotation) =>
        this.openExistentAnnotation(annotation)
      );

      // *****************************************
      // process annotatieons for image with id from evnent
      // *****************************************
      let imageTitleAnnotation =
        this.annotations[event.currentTarget.getAttribute("data-item-id")];
      // console.log(
      //   "this.annotations[event.currentTarget.getAttribute('data-item-id')]",
      //   this.annotations[event.currentTarget.getAttribute("data-item-id")]
      // );

      // console.log("imageTitleAnnotation:", imageTitleAnnotation);

      let countID = 0;

      if (imageTitleAnnotation != undefined) {
        imageTitleAnnotation.forEach((singleAnnotation) => {
          // console.warn("Here you go the id init!");
          console.log("singleAnnotation in forEach: ", singleAnnotation);

          let showAnnotation = JSON.parse(JSON.stringify(this.annotoriousJSON));

          // sidebarObj
          // Score

          if (
            singleAnnotation.content["annotationQuality"] === "machine-detected"
          ) {
            showAnnotation.sidebarObj["score"] =
              (
                parseFloat(
                  singleAnnotation.content["hasBody"].confidenceScore
                ) * 100
              ).toFixed(2) + "%";
          } else {
            showAnnotation.sidebarObj["score"] = "";
          }

          // annotationQuality
          showAnnotation.sidebarObj["annotationQuality"] =
            singleAnnotation.content["annotationQuality"];

          // ID
          showAnnotation.id = `${singleAnnotation.id}_localID_${countID}`;

          // Text comment placeholder
          var createAnnotationCommentText = (comments) => {
            let value = "";
            for (var i in comments) {
              value += `${comments[i].value}<br />`;
            }
            return value;
          };
          showAnnotation.sidebarObj.textComment = createAnnotationCommentText(
            singleAnnotation.content.comments
          );

          // taxonID for Dropdown in the SideBar
          showAnnotation.sidebarObj["taxonID"] =
            singleAnnotation.content["hasBody"]["acceptedNameUsageID"];

          showAnnotation.sidebarObj.ownComment = ""; // default: empty new comment

          // Own annotation
          showAnnotation.sidebarObj["ownAnnotation"] =
            singleAnnotation.metadata.createdBy === this.$keycloak_authorID();

          // END showAnnotation

          // console.warn("taxonID", singleAnnotation.content["hasBody"]);

          // console.log(
          //   "singleAnnotation before annotorious_xywh",
          //   singleAnnotation
          // );
          let annotorious_xywh = singleAnnotation.content["hasTarget"][
            "hasSelector"
          ]["value"]
            .replace("xywh=", "")
            .split(",");

          // Set score for the visualization in the box
          this.annotationScore[showAnnotation.id] =
            showAnnotation.sidebarObj["score"];

          showAnnotation.target.selector.value = `xywh=pixel:${annotorious_xywh}`;

          annotoriousForImage.addAnnotation(showAnnotation);

          countID++;
        });
      }

      this.annotoriousObjects.push(annotoriousForImage);
      // console.log("this.annotoriousObjects", this.annotoriousObjects);

      // Score
      for (var i in this.annotationScore) {
        var selector = `[data-id='${i}']`;

        if (this.annotationScore[i] != "") {
          var targetBoundingBox = document.querySelector(selector);
          var anchorTargetBoundingBox = targetBoundingBox.parentNode.parentNode;

          var x =
            targetBoundingBox.getBoundingClientRect().x -
            anchorTargetBoundingBox.getBoundingClientRect().x +
            2.5;
          var y =
            targetBoundingBox.getBoundingClientRect().y -
            anchorTargetBoundingBox.getBoundingClientRect().y +
            2.5;

          var scoreText = document.createTextNode(
            `Score: ${this.annotationScore[i]}`
          );

          var scoreDiv = document.createElement("div");
          scoreDiv.setAttribute(
            "style",
            `position: absolute; background-color: black; color: white; left:${x}px; top:${y}px; `
          );

          scoreDiv.appendChild(scoreText);

          document.getElementById("app").appendChild(scoreDiv);

          targetBoundingBox.parentNode.parentNode.parentNode.appendChild(
            scoreDiv
          );
        }
      }

      console.groupEnd();
    },

    closeAnnotation() {
      this.sidebarObj = {
        open: false,
        annotationEditMod: this.annotationEditMod,
      };
    },

    deleteAnnotation(id) {
      for (var i in this.annotoriousObjects) {
        if (this.annotoriousObjects[i].getAnnotationById(id)) {
          this.annotoriousObjects[i].removeAnnotation(id);
        }

        var idSplit = id.split("_");

        if (Array.isArray(idSplit)) {
          if (idSplit.length > 1) {
            idSplit = idSplit[0]; // Necessary for some browser.
            this.annotationDeleteCordraObjectID.push(idSplit);
          }
        }
      }
    },

    openExistentAnnotation(annotation) {
      // There is a Annotation from Cordra. Open the Sidebar.
      console.log("openExistentAnnotation", annotation);

      this.closeAnnotation();

      // Original Annotation
      this.sidebarObj["originalAnnotation"] = annotation;

      this.sidebarObj.open = true;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    switchGallery(value) {
      //   console.log('switchGallery, value', value);
      this.gallery = value;
      if (value) {
        document.documentElement.classList.add("o-clipped");
      } else {
        document.documentElement.classList.remove("o-clipped");
      }
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stepBack(cordraResponse) {
      // Here you have to work if its necessary to update capture Event and to set the ID of the Annotation
      if (cordraResponse.type === "AnnotationList") {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let annotationID = cordraResponse.id;
        // this.cordraUpdateCaptureEventIfNecessary(this.objectID, annotationID);
      } else {
        // location.reload(); // TODO: For the moment. Not the best solution because of keycloak.
      }
    },

    cordraGetAnnotation() {
      this.allRelatedAnnotations = {}; // Reset
      this.annotations = {}; // Reset

      for (const singleImage of this.images) {
        const imageAnnotations = singleImage.annotations || [];
        this.allRelatedAnnotations[singleImage.id] = imageAnnotations;
        this.annotations[singleImage.id] = imageAnnotations;
      }

      this.annotationsLoaded = true;
    },

    createAnnotationComment(annotationID, comment) {
      // console.group("createAnnotationComment");

      let annotationObject = {
        type: process.env.VUE_APP_CORDRA_DATATYPE_ANNOTATION,
        content: {
          ["hasTarget"]: {
            source: annotationID,
          },

          hasBody: {
            value: comment,
          },
        },
      };
      // console.groupend();

      return annotationObject;
    },
  },

  computed: {
    ...mapGetters({
      keycloakGetStatusReady: "keycloak/getStatusReady",
      keycloakGetStatusAuthenticated: "keycloak/getStatusAuthenticated",
    }),

    test(active, own) {
      return {
        "img-indicator": active !== own,
        "img-indicator-active": active === own,
      };
    },
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    this.cordraGetAnnotation();
  },
};
</script>

<style scoped>
.image img {
  display: block;
  height: auto;
  width: 100%;
}
.img-indicator {
  filter: grayscale(100%);
}
.img-indicator-active {
  filter: grayscale(0%);
}
.ex-close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #ffffff;
  z-index: 99;
}

/* Dropdown */
/* .media {
  align-items: flex-start;
  display: flex;
  text-align: left;
}
.media-content {
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: left;
  overflow-y: hidden;
  overflow-x: auto;
}
.media-left {
  margin-right: 1rem;
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
} */
</style>
